import JSZip from "jszip";

function normalizeExtension(imageType, fallbackTitle = "") {
    const rawType = String(imageType || "").trim().toLowerCase();
    if (rawType) {
        if (rawType.includes("/")) {
            return rawType.split("/").pop();
        }

        return rawType.replace(/^\./, "");
    }

    const titleParts = String(fallbackTitle || "").split(".");
    return titleParts.length > 1 ? titleParts.pop().toLowerCase() : "bin";
}

export function sanitizeFilenamePart(value, fallback = "untitled") {
    const sanitizedValue = String(value || "")
        .trim()
        .replace(/[<>:"/\\|?*\x00-\x1F]/g, "-")
        .replace(/\s+/g, "_")
        .replace(/-+/g, "-")
        .replace(/_+/g, "_")
        .replace(/^[-_.]+|[-_.]+$/g, "");

    return sanitizedValue || fallback;
}

function buildZipFileName(job) {
    const addressPart = sanitizeFilenamePart(job?.full_address, "job");
    const datePart = sanitizeFilenamePart(job?.date, "unknown-date");
    return `${addressPart}_${datePart}.zip`;
}

function buildImageFileName(image, index) {
    const baseName = sanitizeFilenamePart(image?.title, `image_${index + 1}`);
    const extension = normalizeExtension(image?.image_type, image?.title);
    return baseName.includes(".") ? baseName : `${baseName}.${extension}`;
}

export async function downloadImagesAsZip(job, images = []) {
    const zip = new JSZip();

    await Promise.all(images.map(async (image, index) => {
        const response = await fetch(image.download_url);
        if (!response.ok) {
            throw new Error(`Failed to download image ${image?.title || index + 1}`);
        }

        const blob = await response.blob();
        zip.file(buildImageFileName(image, index), blob);
    }));

    const zipBlob = await zip.generateAsync({type: "blob"});
    const objectUrl = window.URL.createObjectURL(zipBlob);
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = buildZipFileName(job);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(objectUrl);
}
